import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { completeIconSet } from '../../icons/icons-set';

@Component({
    selector: 'app-icon-list',
    templateUrl: './icon-list.component.html',
    styleUrls: ['./icon-list.component.scss'],
})
export class IconListComponent implements OnInit {
    icons = [];
    searchTerm = '';

    constructor(
        private clipboard: Clipboard,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.loadIcons();
    }

    loadIcons() {
        this.icons = [...completeIconSet];
    }

    get filteredIcons() {
        return this.icons.filter((icon) =>
            icon.name.toLowerCase().includes(this.searchTerm.toLowerCase()),
        );
    }

    copyToClipboard(name: string) {
        const fullName = `${name}.svg`;
        this.clipboard.copy(fullName);
        this.toastr.success(`Nome copiado: ${fullName}`);
    }
}
